import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { handleException } from "../../app/util/util";
import { NavDropdownMenu } from "react-bootstrap-submenu";
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
class StudyCenterHeader extends Component {
    constructor(props) {
        super(props);
        const { bookVO } = this.props;
        this.state = {
            bookVO: bookVO,
            navTocType: "none",
            hideNavItems: true,
            chapterVOList: this.props.chapterVOList,
            userVO: JSON.parse(localStorage.getItem('userVO')),
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false",
        }
        this.handleChapterSelection = this.handleChapterSelection.bind(this);
    }
    componentDidMount = () => {
        if (!this.state.chapterVOList)
            this.getChapterAndSupplementalList()
    }
    getChapterAndSupplementalList = () => {
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "studycenter",
                    "pageNavigatingTo": "studycenter",
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                },
            },
            "bookVO": {
                "bookISBN": this.props.match.params.isbn
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/learningObjectiveRetrievalService/getChapterAndSupplementListForStudy", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.chapterVOList) {
                        data.chapterVOList = Array.isArray(data.chapterVOList) ? data.chapterVOList : [data.chapterVOList];
                        this.setState({ "chapterVOList": data.chapterVOList })
                    }
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    handleChapterSelection = (e) => {
        this.setState(prevState => ({
            hideNavItems: !prevState.hideNavItems
        }))
        this.props.history.push(`/study/${this.props.match.params.isbn}/${e.target.getAttribute("chapterId")}`);
        let i = document.querySelector('.dropdown-menu.show');
        i.classList.remove('show');
    }
    render() {
        return (
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding stickyHeaderSet">
                <div id="blueStripContainer" className="bgColorBlueStrip" label="toolbar" aria-label="toolbar">
                    <Navbar collapseOnSelect expand="lg" aria-label="toolbar">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto navBarfontsize">
                                <NavDropdownMenu title="Contents" id="collasible-nav-dropdown">
                                    <div className="navBarScrollBlock">
                                        {
                                            this.state.chapterVOList ? this.state.chapterVOList.map((cList, index) => {
                                                return (
                                                    <NavDropdown.Item href="#" chapterId={cList.chapterId} onClick={this.handleChapterSelection}>
                                                        {cList.navbarTitle}
                                                    </NavDropdown.Item>
                                                )
                                            }) : ""
                                        }
                                    </div>
                                </NavDropdownMenu>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            </div>
        )
    }
}
export default withRouter(StudyCenterHeader);